import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { RootState } from '../../store/types';

/**
 * Use selector hook that infers types from the store.
 */
const useRootSelector: TypedUseSelectorHook<RootState> = useSelector;

export default useRootSelector;
